/**
 * 该文件为脚本自动生成文件，请勿随意修改。如需修改请联系 PMC
 * */

import { TdSearchProps } from './type';

export const searchDefaultProps: TdSearchProps = {
  action: '',
  center: false,
  clearTrigger: 'always',
  clearable: true,
  cursorColor: '#0052d9',
  disabled: false,
  focus: false,
  leftIcon: 'search',
  placeholder: '',
  readonly: undefined,
  resultList: [],
  shape: 'square',
};
